import React from "react";
import styled from "styled-components";
import Typograph from "@material-ui/core/Typography";
import { Divider } from "../../../constants/assets/containers";
import CheckpointProgressBar from "../../Common/CheckPointProgressBar";
import Carousel from "../Carousel";
import { getDashboardUrl } from "../../../views/Home";

const RiderOfferCard = ({ data }) => {
  const rateCardUrl =
    getDashboardUrl()+"/admin/rules_dashboard/view/IncentiveRateCard/" +
    data["rate_card_id"];

  return (
    <CardContainer>
      <CardHeader color={data?.video_tutorial && "#293142"}>
        <OfferDescription>
          <Typograph variant="h6">
            {" "}
            <b> {data["title"]} </b>{" "}
          </Typograph>
          <Typograph variant="subtitle2"> {data["sub_title"]} </Typograph>
        </OfferDescription>

        <OfferValue>
          <Typograph variant="h6">
            {" "}
            <b> {data["amount"]} </b>{" "}
          </Typograph>
          <Typograph variant="subtitle2"> {data["amount_subtitle"]} </Typograph>
        </OfferValue>

        {data?.right_image && (
          <CardImage src={data["right_image"]} alt={data["title"]} />
        )}
      </CardHeader>
      {data?.headers?.length > 0 && (
        <Carousel
          data={data?.headers?.map((header) => ({
            title: header["title"],
            image: header["left_image"],
            leftText: header["left_text"],
          }))}
        />
      )}

      <CardContent>
        {renderResult(data)}
        <Typograph variant="subtitle1">
          {" "}
          <b> {data["description"]} </b>{" "}
        </Typograph>
        {renderOfferProgress(data)}
        {renderOrderPaySlot(data)}
        {renderOrdersTarget(data)}
        <div style={{ height: "16px" }} />
        <Divider height="1px" color={"#ddd"} />
        <div style={{ height: "16px" }} />
        <Typograph variant="subtitle1">
          {" "}
          <b>{data["timing_title"]}</b>{" "}
        </Typograph>
        {renderOfferValidity(data["time"])}
        <div style={{ height: "16px" }} />

        {data?.conditions?.length > 0 && (
          <>
            <Typograph variant="subtitle1">
              {" "}
              <b>Conditions: </b>{" "}
            </Typograph>
            {renderOfferConditions(data["conditions"])}
          </>
        )}

        <div style={{ height: "16px" }} />
        <Typograph variant="subtitle1">
          <b>Rule ID:</b>{" "}
          <a href={rateCardUrl} target="_blank">
            {data["rate_card_id"]}
          </a>
        </Typograph>
        {data?.video_tutorial && (
          <VideoContainerCard
            href={data?.video_tutorial?.video_data?.data[0]?.link}
            target="_blank"
          >
            <VideoImage
              src={data?.video_tutorial?.left_image}
              alt={data["title"]}
            />
            <VideoRight>
              <VideoTitle>{data?.video_tutorial?.title}</VideoTitle>
              <VideoSubTitle>{data?.video_tutorial?.sub_title}</VideoSubTitle>
            </VideoRight>
          </VideoContainerCard>
        )}
        <Typograph variant="subtitle1"></Typograph>
      </CardContent>
    </CardContainer>
  );
};

const renderResult = (data) => {
  if (data["result"] == undefined) {
    return;
  }
  const title = data["result"]["title"];
  const message = data["result"]["message"];

  return (
    <div>
      <Typograph variant="subtitle1">
        <b>{message}</b>
      </Typograph>
      <Typograph variant="subtitle2">{title}</Typograph>
      <div style={{ height: "16px" }} />
      <Divider height="1px" color={"#ddd"} />
      <div style={{ height: "16px" }} />
    </div>
  );
};

const renderOrdersTarget = (data) => {
  if (data["slabs2"] == undefined) {
    return;
  }
  return (
    <Typograph variant="subtitle1">
      <b>Orders done:</b> {data["slabs2"]["progress"]}
    </Typograph>
  );
};

const renderOrderPaySlot = (data) => {
  if (data["order_pay_per_slot"] == undefined) {
    return;
  }
  const slot_pay = data["order_pay_per_slot"];
  const slot_pay_details = data["order_pay_per_slot"]["details"];
  const detail_pay_view = [];
  for (let detail of slot_pay_details) {
    detail_pay_view.push(
      <Typograph variant="subtitle2" style={{ width: "50%" }}>
        {detail["slot_name"]} : {detail["amount"]}
      </Typograph>
    );
  }
  return (
    <div>
      <Divider height="1px" color={"#ddd"} />
      <div style={{ height: "16px" }} />
      <OrderPayPerSlot>
        <Typograph variant="subtitle2" style={{ padding: "4px" }}>
          <b>{slot_pay["title"]}</b>
        </Typograph>
        <Divider height="1px" color={"#ddd"} />
        <OrderPayPerSlotDetails>{detail_pay_view}</OrderPayPerSlotDetails>
      </OrderPayPerSlot>
    </div>
  );
};

const renderOfferProgress = (data) => {
  let slabs = data["slabs"];
  if (slabs == undefined) {
    slabs = {
      progress: data["order_pay_condition"]["progress"],
      headers: {
        upper_label: data["order_pay_condition"]["header"],
        lower_label: "",
      },
      targets: [],
    };
    for (let i = 1; i <= data["order_pay_condition"]["target"]; i++) {
      slabs["targets"].push({
        value: i,
        state:
          i <= data["order_pay_condition"]["progress"]
            ? "ACHIEVED"
            : data["order_pay_condition"]["state"],
        upper_text: "",
        lower_text: i,
      });
    }
  }
  const checkpoints = [];
  const targets = slabs["targets"];
  const maxProgress = Math.max(...targets.map((o) => o["value"]));
  const progress = (slabs["progress"] / maxProgress) * 100;
  const progressUpperLabel = slabs["headers"]["upper_label"];
  const progressLowerLabel = slabs["headers"]["lower_label"];
  const targetGroup = groupTargets(targets);
  for (const idx in targets) {
    const target = targets[idx];
    checkpoints.push({
      progress: (target["value"] / maxProgress) * 100,
      isAchieved: target["state"] == "ACHIEVED" ? true : false,
      upperLabel: targetGroup[target["value"]],
      lowerLabel: target["lower_text"],
    });
  }
  const offerProgressBarProps = {
    checkpoints,
    progress,
    progressUpperLabel,
    progressLowerLabel,
    upperStrikethroughLabel: true,
  };
  return <CheckpointProgressBar data={offerProgressBarProps} />;
};

const getTargetGroup = (targets, isStriked) => {
  const targetGroup = {};
  for (const idx in targets) {
    const target = targets[idx];
    const targetValue = target["value"];
    const isAcheived = target["state"] == "ACHIEVED" ? true : false;
    const labelColor = isAcheived ? "green" : "red";
    const targetLabel = isStriked
      ? target["striked_upper_text"]
      : target["upper_text"];
    if (!targetLabel) continue;
    if (targetGroup[targetValue] == null) {
      targetGroup[targetValue] = `<font 
        style="font-size: 12px;"
        color=${labelColor}> ${targetLabel} </font> `;
    } else {
      targetGroup[
        targetValue
      ] += `, <font style="font-size: 12px;" color=${labelColor}> ${targetLabel} </font> `;
    }
  }
  return targetGroup;
};

const groupTargets = (targets) => {
  const targetGroup = getTargetGroup(targets);
  const strikedTargetGroup = getTargetGroup(targets, true);
  for (const key in strikedTargetGroup) {
    targetGroup[key] += `<br /><font 
    style="text-decoration: line-through; font-size: 12px;"
    color="red">${strikedTargetGroup[key]}</font>`;
  }

  return targetGroup;
};

const renderOfferConditions = (conditions) => {
  return conditions?.map((condition) => (
    <Typograph variant="subtitle2"> • {condition}</Typograph>
  ));
};

const renderOfferValidity = (timings) => {
  return timings?.map((timing) => (
    <Typograph variant="subtitle2"> • {timing}</Typograph>
  ));
};

const OrderPayPerSlot = styled.div`
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  border-radius: 4px;
  padding: 4px;
`;
const OrderPayPerSlotDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 4px;
`;

const OfferDescription = styled.div`
  flex: 0.8;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const OfferValue = styled.div`
  flex: 0.2;
  display: flex;
  flex-direction: column;
  justify-content: right;
  text-align: right;
`;

const VideoContainerCard = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px;
  background-color: #f5f5f5;
  border: 1px solid #596378;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 16px;
  text-decoration: none;
`;

const VideoTitle = styled.div`
  color: #293142;
  font-weight: 600;
  font-size: 16px;
`;

const VideoSubTitle = styled.div`
  color: grey !important;
  font-weight: 500;
  font-size: 13px !important;
  margin-top: 6px;
`;

const VideoImage = styled.img`
  height: 60px;
  width: auto;
  border-radius: 6px;
`;

const VideoRight = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.color || "blue"};
  color: white;
  padding-left: 18px;
  padding-right: 18px;
  padding-top: 18px;
  padding-bottom: 18px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;
const CardContent = styled.div`
  background-color: white;
  padding: 16px;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
`;
const CardContainer = styled.div`
  width: 600px;
  border-radius: 16px;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.15);
`;

const CardImage = styled.img`
  height: 60px;
  width: auto;
`;

export default RiderOfferCard;
